<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div #dropDown data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" role="menu">
  <label class="form-label fs-14 text-default mb-1" *ngIf="label">{{ label }}</label>
  <input
    #searchInput
    type="text"
    class="form-control custom-select"
    [(ngModel)]="searchText"
    [ngModelOptions]="{standalone: true}"
    [placeholder]="placeholder"
    (ngModelChange)="search($event)"
    (blur)="onBlur()"
    [ngClass]="{'border-danger': control?.invalid && control?.touched}"
  />
  <div *ngIf="control?.invalid && control?.touched" class="text-danger small fs-12">
    {{ control?.errors?.required ? `${label} is required` : '' }}
    {{ control?.errors?.pattern ? 'Invalid format' : '' }}
    {{ control?.errors?.minlength ? 'Minimum length is ' + control.errors.minlength.requiredLength : '' }}
    {{ control?.errors?.maxlength ? 'Maximum length is ' + control.errors.maxlength.requiredLength : '' }}
  </div>
</div>
<div #dropdownMenu class="dropdown-menu border-0 p-0">
  <ul *ngIf="(filterOptions$ | async) as options">
    <li class="border-bottom" *ngFor="let option of options | filterByKey: 'label': searchText">
      <a class="dropdown-item" href="javascript:void(0);" (click)="setValue(option, dropDown)">
        <div class="d-flex justify-content-between">
          <div>
            <h5 class="fs-16 fw-medium">{{ option.label }}</h5>
          </div>
        </div>
      </a>
    </li>
  </ul>
</div>
